import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, LinearProgress, Paper, Snackbar, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Tooltip } from '@mui/material';
import React, { Component } from 'react';
import Global from '../../../customlib/Global';
import Api from '../../../customlib/Api';
import axios from 'axios';
import moment from 'moment';
import { AirplaneTicket, AssignmentReturn, Chat, ConfirmationNumber, ErrorOutline, ExpandMore, FactCheck, LocalShipping, Save } from '@mui/icons-material';
import DateRangePickerRich from '../../../customlib/DateRangePickerRich';
import AnalyseDataCancelDialog from './AnalyseDataCancelDialog';
import MessageList from '../../MessageList';
import CreateTicketDataCancelDialog from './CreateTicketDataCancelDialog';

class ReviewSavedAnalysis extends Component {
    state = { 
        startDate: moment(),
        endDate: moment(),
        dataCancelList: [],
        isLoading: false,
        page: 0,
        rowsPerPage: 10,
        totalRecord: 0,
        isDialogOpen: false,
        selectedData: null,
        isSubmiting: false,
        errorMessage: "",
        isLoadingAnalisa: false,
        currentConversation: null,
        isDialogKonfirmasiRevisiOpen: false,
        isSubmitingRevisi: false,
        isCreateTicketDialogOpen: false,
        isSubmitingTicket: false,
        productCategories: [],
        listCity: [],
        showSnackbar: false,
        snackbarMessage: ""
    } 

    handleDateChanged = (dateRange) => {
        if(dateRange && dateRange[0] && dateRange[1]){
            this.setState({startDate: dateRange[0], endDate: dateRange[1]}, () => {
                this.reloadAll();
            })
        }
    }

    handleOpenChat = (data) => {
        const conversation = Global.generateItemConversation(data);
        this.setState({currentConversation: conversation})
    }

    reloadAll = () => {
        this.loadDataCancelList();
    }

    loadDataCancelList = () => {
        this.setState({isLoading: true}, () => {
            var userData = Global.get();
            const params = {
                startDate: this.state.startDate.format("Y-M-D"),
                endDate: this.state.endDate.format("Y-M-D"),
                appProfileId: Global.getAppProfile()._id,
                userId: Global.get().user.id,
                page: this.state.page+1,
                rowsPerPage: this.state.rowsPerPage
            }
        
            console.log("PARAMS", params);
        
            axios
            .post(Api.savedAnalisaList(), params, Api.getRequestHeader())
            .then((response) => {
                const responseData = response.data;
                if(responseData.success === true){
                    this.setState({isLoading: false, dataCancelList: responseData.data.data, totalRecord: responseData.data.recordCount});
                }else{
                    this.setState({isLoading: false, dataCancelList: []});
                }
            })
            .catch((error) => {
                this.setState({isLoading: false});
                console.error("There was an error!", userData.user.id, error);
            });
        });
    }

    loadProductCategories = () => {
        axios
          .get(Api.lavenderGetProductCategories(), Api.getRequestHeaderNoAuth())
          .then((response) => {
            let categories = response.data.categories;
            categories.forEach(item => {
                item.label = item.name;
            });

            this.setState({productCategories: categories});
          })
          .catch((error) => {
            console.error("There was an error!", error);
          });
    };

    getAnalisaByPhone = (data, callback) => {
        this.setState({isLoadingAnalisa: true}, () => {
            var userData = Global.get();
            const params = {
                phoneNumber: data.from
            }
        
            console.log("PARAMS", params);
        
            axios
            .post(Api.getAnalisaByPhone(), params, Api.getRequestHeader())
            .then((response) => {
                const responseData = response.data;
                if(responseData.success === true){
                    this.setState({isLoadingAnalisa: false}, () => {
                        callback(responseData.data);
                    });
                }else{
                    this.setState({isLoadingAnalisa: false, isDialogOpen: false, isCreateTicketDialogOpen: false, selectedData: null}, () => {
                        this.showSnackbar(responseData.message);
                    });
                }
            })
            .catch((error) => {
                this.setState({isLoadingAnalisa: false, isDialogOpen: false, isCreateTicketDialogOpen: false, selectedData: null});
                console.error("There was an error!", userData.user.id, error);
            });
        });
    }

    saveAnalisa = (data) => {
        console.log("DATA", data);
        this.setState({isSubmiting: true}, () => {
            var userData = Global.get();
                const params = {
                    phoneNumber: data?.from,
                    waContactObjectId: data?._id,
                    groupReason: data?.groupReason,
                    reason: data?.reason,
                    appProfileId: Global.getAppProfile()._id,
                    why1: data?.why1 ?? "-",
                    why2: data?.why2 ?? "-",
                    why3: data?.why3 ?? "-",
                    why4: data?.why4 ?? "-",
                    why5: data?.why5 ?? "-",
                    feedback: data?.feedback ?? "-"
                }
                
                if(params.groupReason === null || params.groupReason === undefined || params.groupReason === ""){
                    this.setState({errorMessage: "Group Alasan harus diisi", isSubmiting: false});
                    return;
                }
                
                if(params.reason === null || params.reason === undefined || params.reason === ""){
                    this.setState({errorMessage: "Alasan harus diisi", isSubmiting: false});
                    return;
                }
            
                axios
                .post(Api.saveLeadAnalysis(), params, Api.getRequestHeader())
                .then((response) => {
                    const responseData = response.data;
                    if(responseData.success === true){
                        this.setState({isLoading: false, isSubmiting: false, isDialogOpen: false}, () => {
                            this.showSnackbar(responseData.message);
                            this.reloadAll();
                        });
                    }else{
                        this.setState({isLoading: false, errorMessage: responseData.message}, () => {
                            this.showSnackbar(responseData.message);
                        });
                    }
                })
                .catch((error) => {
                    this.setState({isLoading: false, errorMessage: error});
                    console.error("There was an error!", userData.user.id, error);
                });
        });
    }

    createTicket = (data) => {
        console.log("DATA", data);
        this.setState({isSubmiting: false}, () => {
            var userData = Global.get();
            const params = {
                issue : data?.issue,
                issueCategory : data?.groupReason,
                issueDescription : data?.issueDescription,//*ringkasan masalah
                solution : data?.feedback,
                todo : data?.todo,//* todo
                rootCause : data?.why4,
                pic : Global.get().user.id,
                picName : Global.get().user.name,
                statusApproval : "APPROVED",
                statusPenyelesaian : "IN PROGRESS",
                lotusWhyAnalysisId : data?._id,
                issueSubCategory : data?.reason,
                productCategory : data?.lavenderProductCategory?.id,//*jenis produk
                city : 109876,
                issueDetail : data?.issueDetail//*detail request
            }

            console.log("PARAMSTIKET", params);
            // return;
            
            if(params.issue === null || params.issue === undefined || params.issue === ""){
                this.setState({errorMessage: "Issue belum diisi", isSubmitingTicket: false});
                return;
            }

            if(params.todo === null || params.todo === undefined || params.todo === ""){
                this.setState({errorMessage: "To Do belum ditentukan", isSubmitingTicket: false});
                return;
            }
            if(params.productCategory === null || params.productCategory === undefined || params.productCategory === ""){
                this.setState({errorMessage: "Jenis produk belum ditentukan", isSubmitingTicket: false});
                return;
            }

            if(params.issueDescription === null || params.issueDescription === undefined || params.issueDescription === ""){
                this.setState({errorMessage: "Ringkasan masalah belum diisi", isSubmitingTicket: false});
                return;
            }

            if(params.issueDetail === null || params.issueDetail === undefined || params.issueDetail === ""){
                this.setState({errorMessage: "Detail request belum diisi", isSubmitingTicket: false});
                return;
            }

            // if(params.groupReason === null || params.groupReason === undefined || params.groupReason === ""){
            //     this.setState({errorMessage: "Group Alasan harus diisi", isSubmiting: false});
            //     return;
            // }
            
            // if(params.reason === null || params.reason === undefined || params.reason === ""){
            //     this.setState({errorMessage: "Alasan harus diisi", isSubmiting: false});
            //     return;
            // }
            
            axios
            .post(Api.saveTicketdataCancel(), params, Api.getRequestHeader())
            .then((response) => {
                const responseData = response.data;
                if(responseData.success === true){
                    this.setState({isLoading: false, isSubmitingTicket: false, isCreateTicketDialogOpen: false}, () => {
                        this.showSnackbar(responseData.message)
                        this.reloadAll();
                    });
                }else{
                    this.setState({isLoading: false, errorMessage: responseData.message}, () => {
                        this.showSnackbar(responseData.message);
                    });
                }
            })
            .catch((error) => {
                this.setState({isLoading: false, errorMessage: error});
                console.error("There was an error!", userData.user.id, error);
            });
        });
    }

    revisiAnalisa = () => {
        this.setState({isSubmitingRevisi: true}, () => {
            var userData = Global.get();
                const params = {
                    phoneNumber: this.state.selectedData?.from
                }
                
                axios
                .post(Api.revisiLeadAnalysis(), params, Api.getRequestHeader())
                .then((response) => {
                    const responseData = response.data;
                    if(responseData.success === true){
                        this.setState({isSubmitingRevisi: false, isDialogKonfirmasiRevisiOpen: false}, () => {
                            this.showSnackbar(responseData.message);
                            this.reloadAll();
                        });
                    }else{
                        this.setState({isSubmitingRevisi: false, errorMessage: responseData.message}, () => {
                            this.showSnackbar(responseData.message);
                        });
                    }
                })
                .catch((error) => {
                    this.setState({isSubmitingRevisi: false, errorMessage: error});
                    console.error("There was an error!", userData.user.id, error);
                });
        });
    }

    getCityList = (message) =>{
        let params = {
        };
        // console.log("CITYLIST", JSON.stringify(message));
        axios
        .post(Api.getCityList(), params, Api.getRequestHeader())
        .then((response) => {
            console.log("CITYLIST",response.data);
    
            let cityList = response.data.data;
            // cityList.push({
            //   "id": 0,
            //   "parent_id": 0,
            //   "left": 0,
            //   "right": 0,
            //   "depth": 0,
            //   "name": "Belum diketahui",
            //   "alternames": "[\"Belum diketahui\"]",
            //   "country": "ID",
            //   "level": "ADM2",
            //   "population": 1177042,
            //   "lat": "-7.193300",
            //   "long": "112.553000",
            //   "subadminarea_gmaps_api": "Belum diketahui"
            // });
            this.setState({listCity: cityList});
        })
        .catch((error) => {
            this.setState({ errorMessage: error.message });
            console.error("There was an error!", error);
        });
    }
    
    handleChangePage = (event, newPage) => {
        console.log("NEWPAGE : ", newPage);

        // var isNavigateToNewPage = newPage >= this.state.dataCancelList.length/this.state.rowsPerPage;
        var isNavigateToNewPage = true;

        this.setState({page: newPage}, () => {if(isNavigateToNewPage){this.loadDataCancelList();}});
    };
    
    handleChangeRowsPerPage = (event) => {
        this.setState({page: 0, rowsPerPage: event.target.value});
    };

    componentDidMount() {
        this.loadDataCancelList();
        this.loadProductCategories();
        this.getCityList();
    }

    handleOpenDialog = (selected) => {
        this.setState({selectedData: selected, isDialogOpen: true});
    }

    handleCloseDialog = () => {
        this.setState({isDialogOpen: false, selectedData: null});
    }

    handleOpenDialogKonfirmasiRevisi = (selected) => {
        this.setState({selectedData: selected, isDialogKonfirmasiRevisiOpen: true});
    }

    handleCloseDialogKonfirmasiRevisi = () => {
        this.setState({selectedData: null, isDialogKonfirmasiRevisiOpen: false});
    }

    handleOpenCreateTicketDialog = (selected) => {
        this.setState({selectedData: selected, isCreateTicketDialogOpen: true});
    }

    handleCloseCreateTicketDialog = () => {
        this.setState({isCreateTicketDialogOpen: false, selectedData: null});
    }

    showSnackbar = (message) => {
        this.setState({showSnackbar: true, snackbarMessage: message});
    }

    render() { 

        if(!Global.get().admin && !Global.isTeleLeader()){
            return (
                <div className='container text-center' style={{marginTop: 100}}>
                    <ErrorOutline style={{width: 200, height: 200}} className="text-danger" />
                    <h2>Lotus</h2>
                    <h3>Permission denied</h3>
                    {/* <Link style={{textDecoration: "underline", width: '100%'}} to="/">
                        <div className="btn btn-warning">Back</div>
                    </Link> */}
                </div>
            );
        }
        
        return (
        <Box>
            {/* <Grid container spacing={1}>
                <Grid item xs={10}></Grid>
                <Grid item xs={2}>
                    <DateRangePickerRich title={"Tanggal Transaksi"} startDate={this.state.startDate} endDate={this.state.endDate} onDateChanged={this.handleDateChanged} />
                </Grid>
            </Grid> */}
            <Snackbar
                open={this.state.showSnackbar}
                autoHideDuration={6000}
                onClose={() => this.setState({showSnackbar: false})}
                message={this.state.snackbarMessage}
            />
            {
                !this.props.isMobile && (
                    <TableContainer component={Paper}>
                        <Table sx={{minWidth: 650}}>
                            <TableHead >
                                <TableCell>No</TableCell>
                                <TableCell sx={{minWidth: "120px"}}>Tanggal Lead</TableCell>
                                <TableCell sx={{minWidth: "200px"}}>Nama</TableCell>
                                <TableCell>No Telp</TableCell>
                                <TableCell sx={{minWidth: "220px"}}>Kategori Produk</TableCell>
                                <TableCell sx={{minWidth: "150px"}}>Est Delivery</TableCell>
                                <TableCell sx={{minWidth: "200px"}}>Occasion</TableCell>
                                <TableCell sx={{minWidth: "150px"}}>City</TableCell>
                                <TableCell sx={{minWidth: "120px"}}>Kategori Masalah</TableCell>
                                <TableCell sx={{minWidth: "200px"}}>Sub Kategori</TableCell>
                                <TableCell sx={{minWidth: "200px"}}>Why 1</TableCell>
                                <TableCell sx={{minWidth: "200px"}}>Why 2</TableCell>
                                <TableCell sx={{minWidth: "200px"}}>Why 3</TableCell>
                                <TableCell sx={{minWidth: "200px"}}>Why 4</TableCell>
                                <TableCell sx={{minWidth: "200px"}}>Why 5</TableCell>
                                {/* <TableCell>Lihat Chat</TableCell> */}
                                <TableCell sx={{minWidth: "200px"}}>Feedback/Solusi</TableCell>
                                <TableCell sx={{minWidth: "170px"}}>Action</TableCell>
                            </TableHead>
                            <TableBody>
                                {
                                    this.state.isLoading && (
                                        <TableRow>
                                            <TableCell colSpan={17}>
                                                <LinearProgress />
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                                {
                                    this.state.dataCancelList?.map((item, index) => {
                                        return (
                                            <TableRow hover sx={{fontSize: "10px"}}>
                                                <TableCell>{index+1 + ((this.state.page)*this.state.rowsPerPage)}</TableCell>
                                                <TableCell>{Global.formatDateTimeToStrDate(item.created_at)}</TableCell>
                                                <TableCell>{item.fromName}</TableCell>
                                                <TableCell>{item.from}</TableCell>
                                                <TableCell>{item.productCategory}</TableCell>
                                                <TableCell>{Global.formatDateTimeToStrDateTime24(item.deliveryDate)}</TableCell>
                                                <TableCell>{item.occasion}</TableCell>
                                                <TableCell>{item.cityName}</TableCell>
                                                <TableCell>{item.groupReason ?? ""}</TableCell>
                                                <TableCell>{item.reason ?? ""}</TableCell>
                                                <TableCell>{item.why1 ?? ""}</TableCell>
                                                <TableCell>{item.why2 ?? ""}</TableCell>
                                                <TableCell>{item.why3 ?? ""}</TableCell>
                                                <TableCell>{item.why4 ?? ""}</TableCell>
                                                <TableCell>{item.why5 ?? ""}</TableCell>
                                                {/* <TableCell>Lihat Chat</TableCell> */}
                                                <TableCell>{item.feedback ?? ""}</TableCell>
                                                <TableCell>
                                                    <Tooltip title={"Analisa"}>
                                                        <IconButton color='primary' size='small' onClick={() => this.getAnalisaByPhone(item, this.handleOpenDialog)}><FactCheck /></IconButton>
                                                    </Tooltip>
                                                    <Tooltip title={"Revisi"}>
                                                        <IconButton color='warning' size='small' onClick={() => this.handleOpenDialogKonfirmasiRevisi(item)}><AssignmentReturn /></IconButton>
                                                    </Tooltip>
                                                    <Tooltip title={"Buat Tiket"}>
                                                        <IconButton color='error' size='small' onClick={() => this.getAnalisaByPhone(item, this.handleOpenCreateTicketDialog)}><ConfirmationNumber /></IconButton>
                                                    </Tooltip>
                                                    <Tooltip title={"Lihat Chat"}>
                                                        <IconButton onClick={() => this.handleOpenChat(item)} color='secondary' size='small'><Chat /></IconButton>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })
                                }
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TableCell colSpan={4}>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 25, 50, 75, 100]}
                                            component="div"
                                            count={this.state.totalRecord}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={this.state.page}
                                            onPageChange={this.handleChangePage}
                                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                                        />
                                    </TableCell>
                                    <TableCell colSpan={9}></TableCell>
                                    <TableCell colSpan={4}>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 25, 50, 75, 100]}
                                            component="div"
                                            count={this.state.totalRecord}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={this.state.page}
                                            onPageChange={this.handleChangePage}
                                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                                        />
                                    </TableCell>
                                </TableRow>
                            </TableFooter>
                        </Table>
                    </TableContainer>
                )
            }

            {
                this.props.isMobile && (
                    this.state.dataCancelList?.map(item => {
                        return <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMore />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                            >
                            <Box>
                                <strong>{item.fromName}</strong>
                                <Grid container spacing={1}>
                                    <Grid item xs={6}>{Global.maskPhoneNumber(item.from)}</Grid>
                                    <Grid item xs={6} textAlign={"right"}>{Global.formatDateTimeToStrDate(item.created_at)}</Grid>
                                    <Grid item xs={12}>{item.productCategory}</Grid>
                                </Grid>
                            </Box>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}><LocalShipping />&nbsp;{Global.formatDateTimeToStrDateTime24(item.deliveryDate)}</Grid>
                                    <Grid item xs={12}>{item.occasion}</Grid>
                                    <Grid item xs={12}>{item.cityName}</Grid>
                                    <Grid item xs={12}>{item.groupReason}</Grid>
                                    <Grid item xs={12}>{item.reason}</Grid>
                                    <Grid item xs={12}>
                                        <Box><strong>Why 1</strong></Box>
                                        {item.why1 ?? ""}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box><strong>Why 1</strong></Box>
                                        {item.why2 ?? ""}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box><strong>Why 1</strong></Box>
                                        {item.why3 ?? ""}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box><strong>Why 1</strong></Box>
                                        {item.why4 ?? ""}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box><strong>Why 1</strong></Box>
                                        {item.why5 ?? ""}
                                    </Grid>
                                    <Grid item xs={12} textAlign={"right"}>
                                        <Tooltip title={"Analisa"}>
                                            <IconButton color='primary' size='small' onClick={() => this.getAnalisaByPhone(item, this.handleOpenDialog)}><FactCheck /></IconButton>
                                        </Tooltip>
                                        <Tooltip title={"Revisi"}>
                                            <IconButton color='warning' size='small' onClick={() => this.handleOpenDialogKonfirmasiRevisi(item)}><AssignmentReturn /></IconButton>
                                        </Tooltip>
                                        <Tooltip title={"Buat Tiket"}>
                                            <IconButton color='error' size='small' onClick={() => this.getAnalisaByPhone(item, this.handleOpenCreateTicketDialog)}><ConfirmationNumber /></IconButton>
                                        </Tooltip>
                                        <Tooltip title={"Lihat Chat"}>
                                            <IconButton onClick={() => this.handleOpenChat(item)} color='secondary' size='small'><Chat /></IconButton>
                                        </Tooltip>
                                    </Grid>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>;
                    })
                    
                )
            }

            {
                this.props.isMobile && (
                    <TablePagination
                        rowsPerPageOptions={[10, 25, 50, 75, 100]}
                        component="div"
                        count={this.state.totalRecord}
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.page}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                    />
                )
            }

            {
                this.state.isDialogOpen && 
                    <AnalyseDataCancelDialog errorMessage={this.state.errorMessage} isDialogOpen={this.state.isDialogOpen} onClose={this.handleCloseDialog} onSubmit={this.saveAnalisa} isSubmiting={this.state.isSubmiting} isLoadingAnalisa={this.state.isLoadingAnalisa} selectedData={this.state.selectedData} />
            }

            {
                this.state.isCreateTicketDialogOpen && 
                    <CreateTicketDataCancelDialog listCity={this.state.listCity} productCategories={this.state.productCategories} errorMessage={this.state.errorMessage} isDialogOpen={this.state.isCreateTicketDialogOpen} onClose={this.handleCloseCreateTicketDialog} onSubmit={this.createTicket} isSubmiting={this.state.isSubmitingTicket} isLoadingAnalisa={this.state.isLoadingAnalisa} selectedData={this.state.selectedData} />
            }

            <Dialog
                open={this.state.currentConversation !== null}
                // TransitionComponent={Transition}
                // keepMounted
                onClose={() => {this.setState({currentConversation: null})}}
                aria-describedby=""
            >
                <DialogTitle>
                {/* <strong>{this.state.currentConversation.fromName}</strong>
                <br />
                <strong style={{fontSize: "10px"}}>{this.state.currentConversation.fromNumber}</strong> */}
                </DialogTitle>
                <DialogContent style={{height: "100%"}}>
                    {
                        this.state.currentConversation !== null && (
                            <MessageList
                                onUpdateReadCounter = {()=>{}}
                                onNewIncomingMessage={()=>{}}
                                onUpdateConversations={()=>{}}
                                onUpdateCsHelpState={()=>{}}
                                currentConversation={this.state.currentConversation}
                                onUpdateContactLabelState={()=>{}}
                                onClearCurrentConversation = {()=>{}}
                                onUpdateSlow={()=>{}}
                                onUpdateJustRead={()=>{}}
                                onUpdateUnfinishedChat={()=>{}}
                                onResetUnreadCounter={()=>{}}
                                conversationList={[]}
                                logoutHandler={()=>{}}
                                onSaveCustomerName={()=>{}}
                                style={{maxHeight: "70vh", overflowY: "none"}}
                            />
                        )
                    }
                </DialogContent>
                <DialogActions>
                {/* <Button onClick={handleClose}>Disagree</Button>
                <Button onClick={handleClose}>Agree</Button> */}
                </DialogActions>
            </Dialog>

            <Dialog
                open={this.state.isDialogKonfirmasiRevisiOpen}
                // TransitionComponent={Transition}
                // keepMounted
                onClose={this.handleCloseDialogKonfirmasiRevisi}
                aria-describedby=""
            >
                <DialogTitle>
                    Konfirmasi Revisi
                </DialogTitle>
                <DialogContent style={{height: "100%"}}>
                    Anda ingin analisa untuk customer ini di revisi?
                    <br />
                    <strong>{this.state.selectedData?.fromName} ({this.state.selectedData?.from})</strong>
                    {
                        this.state.isSubmitingRevisi && <LinearProgress sx={{mt: "20px"}} />
                    }
                </DialogContent>
                <DialogActions>
                    <Button disabled={this.state.isSubmitingRevisi} variant='contained' color='warning' sx={{textTransform: "capitalize"}} onClick={this.revisiAnalisa}>
                        Ya, Revisi
                    </Button>
                    <Button variant='contained' color='primary' sx={{textTransform: "capitalize"}} onClick={this.handleCloseDialogKonfirmasiRevisi}>Batal</Button>
                </DialogActions>
            </Dialog>
            
        </Box>
        );
    }
}
 
export default ReviewSavedAnalysis;